Ext.define('SA.EditCheckFieldFactory', {
    singleton: true,

    create({xtype, labelFactory}) {
        var getLabel = id => id === null ? 'None' : labelFactory.create(id);

        return id => Ext.widget({
            xtype,
            cls: 'sa-edit-check-field',
            boxLabel: getLabel(id),
            encodeBoxLabel: !labelFactory.isHtml(),

            getDataId: () => id,

            refreshLabel() {
                this.setLabelHtml(getLabel(id));
            }
        });
    }
});